module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_9016.6db27936.png";